import { render, staticRenderFns } from "./exportRediretModal.vue?vue&type=template&id=22bdf4dc"
import script from "./exportRediretModal.vue?vue&type=script&lang=js"
export * from "./exportRediretModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports